export function ramsWeightedPriorityToColorCode(ramsWeightedPriority: string) {
    switch (ramsWeightedPriority) {
        case '1':
            return '#5ec54b';
        case '2':
            return '#f4b027';
        case '3':
            return '#fd7808';
        case '4':
            return '#d73f2d';
        default:
            return '#6eb3f4';
    }
}
